import classNames from "classnames";

import useTranslate from "hooks/useTranslate";
import { replaceValuesInText } from "utils/replaceValuesInText";
import "./styles.sass";

type LoyaltyInfoExperienceProps = {
  experience: string;
  value: string;
  currency: string;
  className?: string;
};

const LoyaltyInfoExperience = (props: LoyaltyInfoExperienceProps) => {
  const { experience, value, currency, className } = props;
  const t = useTranslate();
  const classNameBlock = classNames("LoyaltyInfoExperience", className);

  return (
    <div className={classNameBlock}>
      {replaceValuesInText(t("loyalty.info.experience"), {
        experience,
        value,
        currency,
      })}
    </div>
  );
};

export default LoyaltyInfoExperience;
